import React from 'react';
import { Info } from 'lucide-react';
import type { BodyEndData } from './types';

interface NoScriptTabProps {
  formData: BodyEndData;
  onInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const NoScriptTab: React.FC<NoScriptTabProps> = ({ formData, onInputChange }) => (
  <div className="space-y-4">
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-start space-x-2">
        <Info size={20} className="text-blue-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-blue-800">
          <p className="font-medium mb-1">NoScript Fallback</p>
          <p>
            Content to display when JavaScript is disabled in the user's browser. Useful for
            accessibility and SEO.
          </p>
        </div>
      </div>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        NoScript Content (HTML)
      </label>
      <textarea
        name="noScriptContent"
        value={formData.noScriptContent}
        onChange={onInputChange}
        rows={6}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono text-sm"
        placeholder="<p>This website requires JavaScript to function properly.</p>"
      />
      <p className="mt-2 text-sm text-gray-500">
        Do not include &lt;noscript&gt; tags - they will be added automatically.
      </p>
    </div>
  </div>
);
